import styled from 'styled-components'

import Label from './Label'

const InputGroup = styled.div`
  ${props => (props.flex ? `flex: ${props.flex};` : '')};

  ${Label} {
    display: block;
  }
`

export default InputGroup
